<template>
    <v-container class="bg-gray vh-full pd20 lynn-web-in">
        <div class="web-side"></div>
        <div class="location-box np">
            <div class="web-logo">
                <Weblogo width="55" height="30" />
            </div>
            <a @click="$router.go(-1)" class="back">
                <Back />
            </a>
            <strong class="lo-title">스마트린 이용약관</strong>
        </div>
        <v-card max-width="750" class="mx-auto bg-gray nops">
            <v-card-text style="padding:16px 4px;">
                <v-row>
                    <v-expansion-panels accordion>
                        <v-expansion-panel>
                            <v-expansion-panel-header>스마트린 이용약관<span
                                    class="sm-title">(필수사항)</span></v-expansion-panel-header>
                            <v-expansion-panel-content style="max-height: 240px; overflow: auto; padding-bottom:20px;"
                                class="text-left">
                                <div class="sl_terms">
                                    <h4>제 1 장 총칙</h4>
                                    <ul>
                                        <li>
                                            <p><b>제 1 조 (목적)</b></p>
                                            <p>
                                                본 약관은 개인정보보호법, 전기통신사업법 및 정보통신망 이용촉진 및 정보보호 등에 관한 법률에 의하여 
                                                우미건설㈜(계열사를 포함하며, 이하 "회사"라 한다)이 제공하는 회원 서비스(이하 "서비스"라 한다)의 이용 조건, 
                                                절차 그리고 회원규칙에 관한 사항 등을 규정함을 목적으로 합니다. 
                                            </p>
                                        </li>
                                        <li>
                                            <p><b>제 2 조 (공지)</b></p>
                                            <ol>
                                                <li>1. 본 규정은 서비스 화면에 게시하거나 기타의 방법으로 회원에게 공지함으로써 효력을 발생합니다.</li>
                                                <li>2. 회사는 “개인정보보호법”, “약관의규제에관한법률”, “정보통신망이용촉진및정보보호등에관한법률” 등 관련법을 위배하지 않는 범위에서 본 규정을 변경할 수 있으며, 변경된 규정은 제1항과 같은 방법으로 공지함으로써 효력을 발생합니다.</li>
                                            </ol>
                                        </li>
                                        <li>
                                            <p><b>제 3 조 (약관 외 준칙)</b></p>
                                            <p>본 약관에 규정되지 않은 사항은 전기통신사업법 및 정보통신망 이용촉진 및 정보보호 등에 관한 법률 기타 관련법령의 규정에 의합니다. </p>
                                        </li>
                                        <li>
                                            <p><b>제 4 조 (용어의 정의)</b></p>
                                            <p>본 약관에서 사용하는 용어의 정의는 다음과 같습니다.</p>
                                            <ol>
                                                <li>1. “이용자”이라 함은 회사와 서비스 이용계약을 체결한 자를 말합니다.</li>
                                                <li>2. “이용자 ID”라 함은 “회원”의 식별과 서비스 이용을 위하여 “회원”이 정하고 회사가 승인하는 문자와 숫자의 조합을 의미합니다.</li>
                                                <li>3. “비밀번호”라 함은 이용자ID와 일치된 “회원”이 이용자임을 확인하고 “회원” 자신의 비밀을 보호하기 위하여 “회원” 자신이 설정한 문자와 숫자의 조합을 말합니다.</li>
                                                <li>4. “운영자”라 함은 서비스의 전반적인 관리와 원활한 운영을 위하여 회사에서 선정한 사람을 말합니다.</li>
                                            </ol>
                                        </li>
                                    </ul>
                                </div>
                                <div class="sl_terms">
                                    <h4>제 2 장 서비스 이용 계약</h4>
                                    <ul>
                                        <li>
                                            <p><b>제 5 조 (이용계약의 성립)</b></p>
                                            <ol>
                                                <li>1. 이용계약은 이용자가 이용 약관에 대한 "동의" 버튼을 클릭하면 이 약관에 동의하는 것으로 간주하며, 이용자는 회원가입신청을 하여야 합니다.</li>
                                                <li>2. 이용계약은 이용자의 가입 신청에 대하여 회사가 승낙함으로써 성립합니다.</li>
                                            </ol>
                                        </li>
                                        <li>
                                            <p><b>제 6 조 (이용계약의 유보 및 거절)</b></p>
                                            <ol>
                                                <li>
                                                    1. 회사는 다음에 해당하는 경우에는 이용계약의 승낙을 유보할 수 있습니다.
                                                    <ol>
                                                        <li>가. 서비스 설비용량에 여유가 없는 경우</li>
                                                        <li>나. 서비스를 제공하기에는 기술적으로 문제가 있다고 판단되는 경우</li>
                                                        <li>다. 기타 회사가 필요하다고 인정되는 경우</li>
                                                    </ol>
                                                </li>
                                                <li>
                                                    2. 회사는 다음에 해당하는 경우에는 이용계약의 승낙을 거절할 수 있습니다.
                                                    <ol>
                                                        <li>가. 본인 실명과 다르게 이용신청을 하였을 경우</li>
                                                        <li>나. 이용신청서의 내용을 허위로 기재하였거나 허위서류를 첨부하여 이용신청을 하였을 경우</li>
                                                    </ol>
                                                </li>
                                            </ol>
                                        </li>
                                        <li>
                                            <p><b>제 7 조 (이용자ID 등의 관리)</b></p>
                                            <ol>
                                                <li>1. 이용자ID는 본인실명으로 개인에게 하나만을 발급하는 것을 원칙으로 합니다.</li>
                                                <li>2. 이용자ID는 본명(실명)이 이용자명과 연계되어야 합니다. 이용자ID를 소유한 이용자는 이용자ID 및 비밀번호에 대한 관리 책임이 있으며, 서비스 이용상의 과실 또는 제 3자에 의한 부정사용 등으로 인해 발생하는 모든 불이익에 대해 책임을 져야 합니다. 다만 회사에 고의 또는 중대한 과실이 있는 경우에는 그러하지 않습니다.</li>
                                            </ol>
                                        </li>
                                        <li>
                                            <p><b>제 8 조 (이용계약사항의 변경) </b></p>
                                            <ol>
                                                <li>
                                                    1. 이용자는 다음에 해당하는 변경사항이 있을 경우에는 회원정보관리화면을 통하여 언제든지 본인의 개인정보를 열람하고 수정할 수 있습니다. 단, 이러한 변경사항을 회사에 알리지 않아 발생한 불이익에 대하여 회사는 책임지지 않습니다.
                                                    <ol>
                                                        <li>가. 휴대전화</li>
                                                        <li>나. 비밀번호</li>
                                                        <li>다. 기타 회사가 인정하는 사항</li>
                                                    </ol>
                                                </li>
                                                <li>
                                                    2. 이용자ID는 다음에 해당할 경우 이용자의 요청에 의하여 변경할 수 있습니다. 
                                                    <ol>
                                                        <li>가. 이용자의 전화번호, 주민등록번호 등으로 등록되어 사생활 침해가 우려되는 경우</li>
                                                        <li>나. 타인에게 혐오감을 주는 경우</li>
                                                        <li>다. 기타 회사가 인정하는 경우</li>
                                                    </ol>
                                                </li>
                                            </ol>
                                        </li>
                                    </ul>
                                </div>
                                <div class="sl_terms">
                                    <h4>제 3 장 서비스 이용</h4>
                                    <ul>
                                        <li>
                                            <p><b>제 9 조 (회사의 의무)</b></p>
                                            <p>
                                                회사는 서비스 제공과 관련해서 알고 있는 이용자의 신상정보를 본인의 승낙 없이 제 3자에게 누설, 배포하지 않습니다. 
                                                단, 전기통신기본법 등 법률의 규정에 의해 국가기관의 요구가 있는 경우, 범죄에 대한 수사상의 목적이 있거나 
                                                정보통신윤리위원회의 요청이 있는 경우 또는 기타 관계법령에서 정한 절차에 따른 요청이 있는 경우에는 그러하지 않습니다.
                                            </p>
                                        </li>
                                        <li>
                                            <p><b>제 10 조 (이용자의 이용자 ID와 비밀번호 관리에 대한 의무)</b></p>
                                            <ol>
                                                <li>1. 이용자 ID와 비밀번호에 관한 모든 관리 책임은 이용자에게 있습니다. 이용자 ID와 비밀번호의 관리 소홀, 부정사용 등에 의하여 발생하는 모든 결과에 대한 책임은 이용자에게 있습니다.</li>
                                                <li>2. 자신의 이용자 ID와 비밀번호가 부정하게 사용되고 있음을 발견한 이용자는 즉시 회사에 그 사실을 통보해야 합니다.</li>
                                            </ol>
                                        </li>
                                        <li>
                                            <p><b>제 11 조 (서비스 전반에 관한 이용자의 의무)</b></p>
                                            <ol>
                                                <li>
                                                    1. 이용자는 서비스 이용 시 다음 각 호의 행위를 하지 않아야 합니다.
                                                    <ol>
                                                        <li>① 다른 이용자의 이용자 ID를 부정하게 사용하는 행위</li>
                                                        <li>② 서비스에서 얻은 정보를 회사의 사전승낙 없이 이용자의 이용 외의 목적으로 복제하거나 출판 및 방송 등에 사용하거나 제3자에게 제공하는 행위</li>
                                                        <li>③ 제3자의 저작권 등 기타 권리를 침해하는 행위</li>
                                                        <li>④ 공공질서 및 미풍양속에 위반되는 내용의 정보, 문장, 도형 등을 타인에게 유포하는 행위</li>
                                                        <li>⑤ 범죄와 결부된다고 객관적으로 판단되는 행위</li>
                                                        <li>⑥ 타인의 명예를 훼손하거나 불이익을 주는 행위</li>
                                                        <li>⑦ 기타 관계법령 및 본 약관을 위배하는 행위</li>
                                                    </ol>
                                                </li>
                                                <li>2. 이용자는 본 약관에서 규정하는 사항과 회사가 서비스 이용안내 또는 주의사항 등 회사가 공지하는 사항을 준수하여야 합니다.</li>
                                                <li>3. 이용자는 회사의 사전승낙 없이는 서비스를 이용하여 영업활동을 할 수 없으며, 그 영업활동으로 인하여 발생된 결과에 대하여 회사는 어떠한 책임도 지지 않습니다.</li>
                                            </ol>
                                        </li>
                                        <li>
                                            <p><b>제 12 조 (서비스 이용시간)</b></p>
                                            <ol>
                                                <li>1. 서비스의 이용은 회사의 업무상 또는 기술상 특별한 지장이 없는 한 1일 24시간, 연중 무휴서비스를 원칙으로 합니다. 다만, 시스템 점검, 교체, 보수 등과 같은 필요가 있는 경우는 그러하지 않습니다.</li>
                                                <li>2. 회사는 서비스를 일정범위로 분할하여 각 범위별로 이용가능시간을 별도로 정할 수 있습니다.</li>
                                            </ol>
                                        </li>
                                        <li>
                                            <p><b>제 13 조 (서비스 제공의 중지)</b></p>
                                            <ol>
                                                <li>1. 회사는 전시사변, 천재지변 또는 이에 준하는 국가비상사태가 발생하거나 발생할 우려가 있는 경우와 전기통신사업법에 의한 기간통신사업자가 전기통신 서비스를 중지하는 등 기타 부득이한 사유가 있는 경우에는 서비스의 전부 또는 일부를 제한하거나 정지할 수 있습니다.</li>
                                                <li>2. 회사는 전 항의 규정에 의하여 서비스의 이용을 제한하거나 정지한 때에는 그의 사유 및 제한기간 등을 지체 없이 이용자에게 공지합니다.</li>
                                            </ol>
                                        </li>
                                    </ul>
                                </div>
                                <div class="sl_terms">
                                    <h4>제 4 장 계약 해지 및 이용 제한</h4>
                                    <ul>
                                        <li>
                                            <p><b>제 14 조 (계약해지 및 이용제한)</b></p>
                                            <ol>
                                                <li>1. 이용자가 이용계약을 해지하고자 하는 때는 본인이 온라인을 통해 회사에 해지를 신청하여야 하며, 이 경우 회사는 관련 법령 등이 정하는 바에 따라 처리합니다.</li>
                                                <li>2. 회사가 서비스 이용을 제한하고자 하는 경우 그 사유와 일시 등을 이용자에게 통지합니다. 다만, 회사가 긴급하게 이용을 정지할 필요가 있다고 인정하는 경우에는 바로 제재를 가할 수 있습니다.</li>
                                                <li>3. 전 항의 규정에 의하여 이용정지를 통지 받은 이용자는 그 이용 정지의 통지에 대해 부당하다고 생각할 경우 이의신청을 할 수 있습니다.</li>
                                                <li>4. 회사는 전 항의 규정에 의한 이의신청에 대하여 그 확인을 위한 기간까지 이용정지를 일시 연기할 수 있으며, 그 경과와 결과를 이용 고객에게 통지합니다.</li>
                                                <li>5. 회사는 이용정지 기간 중에 그 이용정지 사유가 해소된 것이 확인된 경우에는 이용정지 조치를 즉시 해제합니다.</li>
                                            </ol>
                                        </li>
                                    </ul>
                                </div>
                                <div class="sl_terms">
                                    <h4>제 5 장 손해배상 등</h4>
                                    <ul>
                                        <li>
                                            <p><b>제 15 조 (손해 배상)</b></p>
                                            <p>회사는 서비스가 무료인 동안 서비스 이용과 관련하여 이용자에게 발생한 손해에 대하여는 어떠한 책임도 지지 않습니다. 서비스 유료화 이후에 관하여는 별도로 정합니다.</p>
                                        </li>
                                        <li>
                                            <p><b>제 16 조 (면책조항)</b></p>
                                            <ol>
                                                <li>1. 회사는 천재지변 기타 불가항력적인 사유로 인해 서비스를 제공할 수 없는 경우에는 서비스 제공중지에 대한 책임이 면제 됩니다.</li>
                                                <li>2. 회사는 이용자의 귀책사유로 인한 서비스 이용의 장애에 대하여는 책임을 지지 않습니다.</li>
                                                <li>3. 회사는 이용자가 서비스를 이용하여 얻은 정보 등으로 인해 입은 손해 등에 대하여는 책임을 지지 않습니다.</li>
                                                <li>4. 회사는 서비스에 제공하는 정보에 대하여 정확성을 책임지지 않으며, 이용자는 입주자모집공고 등 직접 정보의 내용을 확인하여야 하고, 이를 확인하지 않아 발생한 손해 등에 대하여는 책임을 지지 않습니다.</li>
                                                <li>5. 회사는 회사의 서비스망을 통해 제공되는 IP 정보와 이용자가 게시하거나 전송한 정보 등의 신뢰도나 정확성에 대하여는 책임을 지지 않습니다.</li>
                                            </ol>
                                        </li>
                                        <li>
                                            <p><b>제 17조 (준거법 및 재판관할)</b></p>
                                            <ol>
                                                <li>1. 회사와 회원간 제기된 소송은 대한민국법을 준거법으로 합니다.</li>
                                                <li>2. 회사와 회원간 발생한 분쟁에 관한 소송은 민사소송법 상의 관할법원에 제소합니다.</li>
                                            </ol>
                                        </li>
                                    </ul>
                                </div>
                                <div class="bot_txt">
                                    <p>[부칙] 이 약관은 공시일로부터 시행합니다.</p>
                                </div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-row>
                <v-row class="mt5 Reterms">
                    <v-radio-group v-model="serviceCheck" row>
                        <v-radio :value="true">
                            <template v-slot:label>
                                <div class="checkText">동의함</div>
                            </template>
                        </v-radio>
                        <v-radio :value="false">
                            <template v-slot:label>
                                <div class="checkText">동의안함 <span>(동의해야 회원가입 가능)</span></div>
                            </template>
                        </v-radio>
                    </v-radio-group>
                </v-row>

                <v-row>
                    <v-expansion-panels accordion>
                        <v-expansion-panel>
                            <v-expansion-panel-header>개인정보 수집 및 이용안내<span
                                    class="sm-title">(필수사항)</span></v-expansion-panel-header>
                            <v-expansion-panel-content style="max-height: 240px; overflow: auto" class="text-left">
                                <div class="text_area">
                                    <div class="para">
                                        <p class="tit">
                                            개인정보의 수집 및 이용 목적
                                        </p>
                                        <p>회사는 회사가 운영하는 인터넷 사이트와 앱을 통합하여 운영합니다. 따라서 이용자는 당사가 운영하는 브랜드 사이트와 생활플랫폼 앱을 동일 아이디(이메일)와 비밀번호(P/W)로 로그인하여 이용할 수 있습니다.</p>
                                        <p>
                                            회사는 다음과 같은 이유로 개인정보를 수집합니다.
                                        </p>

                                    </div>
                                    <div class="para">
                                        <p class="subtit">
                                            1. 홈페이지 서비스 제공 및 회원관리
                                        </p>
                                        <p>
                                            - 이용자 식별 및 본인여부 확인, 홈페이지 이용,
                                            맞춤형 서비스 제공, 사용자 통계 및 분석을 통한
                                            서비스 개선, 홈페이지에서 제공하는 각종 서비스
                                            신청 및 이용
                                        </p>
                                        <p>
                                            - 아이디(이메일), 휴대전화 인증 : 회원제 서비스
                                            이용에 따른 식별 절차에 이용
                                        </p>
                                    </div>
                                    <div class="para">
                                        <p class="subtit">
                                            2. 마케팅 및 광고에 활용 (마케팅 목적 개인정보 수집 및 이용 동의자 대상)
                                        </p>
                                        <p>- 분양/브랜드 홍보, 이벤트 및 광고성 정보의 제공</p>
                                    </div>
                                    <div class="para">
                                        <p class="tit">
                                            개인정보의 수집항목 수집방법
                                        </p>
                                        <p>
                                            회사는 회원가입 시 서비스 이용을 위해
                                            필요한 최소한의 개인정보만을 수집합니다
                                        </p>
                                    </div>
                                    <div class="para">
                                        <p class="subtit">
                                            1. 수집항목
                                        </p>
                                        <ul>
                                            <li><b>1)</b>회원가입 : 이름, 아이디(이메일), 실명인증 값</li>
                                            <li><b>2)</b>본인확인 : 성명, 생년월일, 성별,
                                                휴대전화번호, 내/외국인 정보</li>
                                            <li><b>3)</b>관심고객 등록 : 이름, 휴대전화번호, 연령, 성별, 이메일, 주소
                                            </li>
                                            <li><b>4)</b>견본주택 방문예약 : 이름, 방문자
                                                휴대전화번호, 방문단지</li>
                                            <li><b>5)</b>사전 점검 예약 : 이름, 방문자 휴대전화번호,
                                                방문단지</li>
                                            <li><b>6)</b>입주 예약 : 이름, 입주자 휴대전화번호,
                                                입주단지
                                            </li>
                                            <li><b>7)</b>A/S문의 : 이름, 휴대전화번호, 이메일,
                                                입주단지</li>
                                            <li><b>8)</b>1:1문의 : 이름, 휴대전화번호, 이메일,
                                                계약단지
                                            </li>
                                            <li><b>9)</b>이벤트 및 고객만족도 설문조사 : 이름, 휴대전화번호, 계약(입주)단지 동호수</li>

                                        </ul>
                                    </div>
                                    <div class="para">

                                            <p class="subtit">
                                                <b>2.</b>개인정보 수집방법: 고객이 홈페이지에서 직접 입력 및 자동 수집, 본인인증 시 확인
                                            </p>
                                    </div>

                                    <div class="para">
                                        <p class="tit">
                                            개인정보의 처리 및 보유기간
                                        </p>
                                        <p>
                                            회사는 개인정보 수집 및 처리목적이 달성된
                                            후에는 예외 없이 해당 정보를 지체 없이
                                            파기합니다. 단, 다음의 정보에 대해서는 아래의
                                            기간 동안 보유합니다.
                                        </p>
                                    </div>

                                    <div class="para">
                                        <p class="subtit">
                                            1. 회원관리
                                        </p>
                                        <p>
                                            - 홈페이지 회원에 관한 기록: 회원 탈퇴 시 파기 <br>
                                            - 본인 의사 및 요청에 의한 탈퇴 시 파기<br>
                                            - 단순 문의 및 상담 고객에 관한 기록: 문의사항
                                            처리 완료 후 3개월 (사후 A/S 대응을 위한 보관)
                                        </p>
                                    </div>
                                    <div class="para">
                                        <p class="subtit">
                                            2. 관심단지 등록 정보 및 견본주택방문
                                        </p>
                                        <p>
                                            - 분양종료 또는 정보주체의 삭제 요청 시
                                        </p>
                                    </div>
                                    <div class="para">
                                        <p class="subtit">
                                            3. A/S 관련사항
                                        </p>
                                        <p>
                                            - A/S 처리: 입주지정일로부터 10년 <br>
                                            - A/S 접수 및 처리 기록: 접수일로부터 10년

                                        </p>
                                    </div>
                                    <div class="para">
                                        <p class="subtit">
                                            4. 1:1문의, 온라인문의
                                        </p>
                                        <p>
                                            - 접수일로부터 3년
                                        </p>
                                    </div>
                                    
                                    <div class="para">
                                        <p class="subtit">
                                            5. 이벤트 및 고객만족도 설문조사 (마케팅 목적 개인정보 수집 및 이용 동의자 대상)
                                        </p>
                                        <p>
                                            - 참여일로부터 이벤트 및 설문조사 종료 시까지(경품 발송 완료 시)
                                        </p>
                                    </div>
                                    <div class="para">
                                        <p class="subtit">
                                            6. 그 외 관련 법령에 의한 정보보유
                                        </p>
                                        <p>
                                            - 본인확인에 관한 기록 : 「정보통신망 이용촉진
                                            및 정보보호 등에 관한 법률」 제23조의 3 (본인
                                            확인기관의 지정 등) 에 따라 6개월 이내 <br>
                                            - 웹사이트 방문기록 보존 이유 :「통신비밀
                                            보호법」시행령 제41조(전기통신사업자의
                                            협조의무 등)의 2항에 따라 3개월 이상
                                        </p>

                                    </div>
                                </div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-row>
                <v-row class="mt5 Reterms">
                    <v-radio-group v-model="privacyCheck" row>
                        <v-radio :value="true">
                            <template v-slot:label>
                                <div class="checkText">동의함</div>
                            </template>
                        </v-radio>
                        <v-radio :value="false">
                            <template v-slot:label>
                                <div class="checkText">동의안함 <span>(동의해야 회원가입 가능)</span></div>
                            </template>
                        </v-radio>
                    </v-radio-group>
                </v-row>

                <v-row>
                    <v-expansion-panels accordion>
                        <v-expansion-panel>
                            <v-expansion-panel-header>개인정보 취급위탁에 대한 안내<span
                                    class="sm-title">(필수사항)</span></v-expansion-panel-header>
                            <v-expansion-panel-content style="max-height: 240px; overflow: auto" class="text-left">
                                <div class="text_area">
                                    <div class="para">
                                        <p class="tit">
                                            개인정보의 처리 위탁
                                        </p>
                                        <p>
                                            회사는 서비스 향상을 위해서 아래와 같이
                                            개인정보를 위탁하고 있으며, 관계 법령에 따라
                                            위탁계약 시 개인정보가 안전하게 관리될 수
                                            있도록 필요한 사항을 규정하고 있습니다.
                                            회사의 개인정보 위탁업체 및 위탁업무 내용은
                                            아래와 같습니다.
                                        </p>
                                        <div class="table_wrap">
                                            <table>
                                                <colgroup>
                                                    <col style="width:35%">
                                                    <col style="width:35%">
                                                    <col style="width:30%">
                                                </colgroup>
                                                <thead>
                                                    <tr>
                                                        <th>위탁업무내용</th>
                                                        <th>위탁업체</th>
                                                        <th>개인정보의 보유 및 이용기간</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>전산시스템 구축 및 유지보수</td>
                                                        <td>삼성SDS, 휴먼플러스, 파도시스템</td>
                                                        <td>위탁계약 종료 혹은 처리중지 요청 시 까지</td>
                                                    </tr>
                                                    <tr>
                                                        <td>홈페이지 운영 및 유지보수</td>
                                                        <td>더위버크리에이티브</td>
                                                        <td>위탁계약 종료 혹은 처리중지 요청 시 까지</td>
                                                    </tr>
                                                    <tr>
                                                        <td>분양대행/마케팅 <br>(마케팅 목적 개인정보 수집 및 이용 동의자 대상)</td>
                                                        <td>삼일산업, 마켓리더, SDPMC, 위드알앤씨, 엠비앤홀딩스, 정원 C&amp;D</td>
                                                        <td>위탁계약 종료 혹은 처리중지 요청 시 까지</td>
                                                    </tr>
                                                    <tr>
                                                        <td>입주대행</td>
                                                        <td>드림하우스, 가온하우스, 플랜하우스, 태현에이치씨, 하우스앤피플, 유앤미, (주)더좋은사람들</td>
                                                        <td>위탁계약 종료 혹은 처리중지 요청 시 까지</td>
                                                    </tr>
                                                    <tr>
                                                        <td>고객상담, A/S접수</td>
                                                        <td>시공협력사(단지내AS센터 또는 관리사무소에서 확인가능), 하자보수 업무 위탁사, 심우건설, <br>명일건설, 명상건설, 전승건설, 심우종합건설</td>
                                                        <td>위탁계약 종료 혹은 처리중지 요청 시 까지</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-row>
                <v-row class="mt5 Reterms">
                    <v-radio-group v-model="consignCheck" row>
                        <v-radio :value="true">
                            <template v-slot:label>
                                <div class="checkText">동의함</div>
                            </template>
                        </v-radio>
                        <v-radio :value="false">
                            <template v-slot:label>
                                <div class="checkText">동의안함 <span>(동의해야 회원가입 가능)</span></div>
                            </template>
                        </v-radio>
                    </v-radio-group>
                </v-row>

                <v-row>
                    <v-expansion-panels accordion>
                        <v-expansion-panel>
                            <v-expansion-panel-header>마케팅 목적 개인정보 수집 및 이용 동의<span
                                    class="sm-ntitle">(선택사항)</span></v-expansion-panel-header>
                            <v-expansion-panel-content style="max-height: 240px; overflow: auto" class="text-left">
                                <div class="text_area">
                                    <div class="table_wrap" style="margin-top:0;">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>수집 및 이용 항목</th>
                                                    <th>수집 및 이용 목적</th>
                                                    <th>보유 및 이용기간</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>성명, 이메일, 휴대전화번호</td>
                                                    <td>분양 홍보 및 이벤트 안내</td>
                                                    <td>회원탈퇴 시 삭제 또는 동의철회 시 이용중지</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-row>
                <v-row class="mt5 Reterms">
                    <v-radio-group v-model="marketCheck" row>
                        <v-radio :value="true">
                            <template v-slot:label>
                                <div class="checkText">동의함</div>
                            </template>
                        </v-radio>
                        <v-radio :value="false">
                            <template v-slot:label>
                                <div class="checkText">동의안함 <span>(동의하지 않아도 회원가입 가능)</span></div>
                            </template>
                        </v-radio>
                    </v-radio-group>
                </v-row>
            </v-card-text>
            <v-btn color="primary" class="fts18 ftw7 mw-400 pwidth100" min-height="50" @click="check()">확인</v-btn>
        </v-card>
    </v-container>
</template>

<script>
import Back from "@/assets/images/icon/icon-back.svg";
import Weblogo from "@/assets/images/common/new-logo.svg";

export default {
    components: { Back, Weblogo, },
    name: "signUpAgreement",
    data() {
        return {
            serviceCheck: false,
            privacyCheck: false,
            consignCheck: false,
            marketCheck: false,
        };
    },
    methods: {
        check() {
            if (this.serviceCheck === true && this.privacyCheck === true && this.consignCheck === true) {
                this.$router.push({ name: "signup", query: { redirect: this.$route.query.redirect, agreement: this.marketCheck } });
            } else {
                alert("이용 약관, 개인정보 수집, 개인정보 취급위탁에 모두 동의하셔야 합니다.");
                return;
            }
        },
    },
};
</script>

<style scoped>
.v-input .v-label {
    font-size: 14px;
}

.text_area {
    color: #666666;
}

.text_area * {
    word-wrap: keep-all;
}

.text_area .para {
    margin-bottom: 30px;
}

.text_area .para:last-child {
    margin-bottom: 0px;
    padding-bottom: 5px;
}

.text_area .para p {
    display: block;
    padding-left: 0;
}

.text_area .para .subtit {
    padding-left: 0;
}

.text_area .para .tit {
    color: #333333;
    font-weight: 500;
}

.text_area .para ul {
    padding-left: 0;
}

.text_area .para ul li {
    padding: 0px;
    display: flex;
    padding-left: 10px;
    word-break: ke;
}

.text_area .para ul li b {
    display: inline-block;
    height: 100%;
    margin-right: 5px;
}

.text_area .table_wrap {
    margin-top: 20px;
    width: 100%;
    overflow: auto;
    border-top: 1px solid #372511;
}

.text_area table {
    width: 100%;
}

.text_area table th {
    font-weight: 500;
    color: #333333;
    padding: 15px 5px;
    text-align: center;
    background: #F8F8F8;
    border: 1px solid #DDDDDD;
}

.text_area table tr td {
    padding: 15px 5px;
    text-align: center;
    border: 1px solid #DDDDDD;
}

.sl_terms h3 {
    font-size: 30px;
    font-weight: 500;
    text-align: center;
    padding: 40px 0 28px
}

.sl_terms h4 {
    font-size: 18px;
    font-weight: 500;
    padding-bottom: 15px
}

.sl_terms ul > li + li {
    margin-top: 34px
}

.sl_terms ul > li p + p {
    margin-top: 5px
}

.sl_terms ul > li ol {
    margin: 10px 0
}

.sl_terms ul > li ol li {
    padding-left: 15px;
    text-indent: -15px;
    word-break: keep-all
}

.sl_terms ul > li ol li + li {
    margin-top: 10px
}

.sl_terms ul > li ol li ol li {
    padding-left: 18px;
    text-indent: -18px
}

.sl_terms ul > li ol li ol li + li {
    margin-top: 5px
}

.bot_txt {
    padding-bottom: 5px;
}

.bot_txt p {
    font-size: 14px;
    font-weight: 500;
}

.sm-title {
    margin-left: 4px;
    color: #f36628
}

.sm-ntitle {
    flex: 0 0 auto;
    margin-left: 4px;
    color: #f36628;
}

.checkText {
    font-size: 14px;
    color: #333333;
}

.checkText span {
    font-size: 13px;
    color: #333333;
}

.v-expansion-panel-header {
    padding: 12px 14px;
}
</style>